import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const CarouselSecundarios = ({
  dataCAR,
  handleImageClick,
  handleCasillaModal,
  handleOpenModal,
}) => {

  const dataCAROrdenado = [...dataCAR].sort((a, b) => b.id - a.id);

  return (
    <>
      <style>
{`
  /* Marco donde va la imagen */
  .carousel-wrapper {
    width: 100%;
    height: 380px;   /* ⬅️ AUMENTADO */
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f5f5;
    border-radius: 12px;
    overflow: hidden;
  }

  /* Imagen que se adapta sin deformarse */
  .carousel-img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
  }

  /* Centra todo dentro del slide */
  .swiper-slide {
    display: flex !important;
    justify-content: center;
    align-items: center;
  }
`}
</style>


<div className="row g-3 mb-5"> 

        {/* ACTIVIDADES */}
        <h3 className="bottom_title mt-3 mb-3 enlaces-custom">
            Actividades de Interés
          </h3>
        <div className="col-md-2"></div>
        <div className="col-md-8">
          

          <div className="card">
            <div className="card-body">

              <Swiper
                modules={[Navigation, Autoplay]}
                navigation
                autoplay={{ delay: 4000 }}
                loop
                spaceBetween={10}
                slidesPerView={1}
              >
                {dataCAROrdenado.map((item) => (
                  <SwiperSlide key={`car-${item.id}`}>
                    <div className="carousel-wrapper">
                      <img
                        src={`https://itetlax.org.mx/assets/img/imgCAR/${item.imgUrl}`}
                        alt={item.alt}
                        className="carousel-img"
                        onClick={(e) => {
                          if (item.id === 6) handleImageClick(e, item);
                          else if (item.id === 10) handleCasillaModal(e, item);
                          else if (item.url) window.open(item.url, "_blank");
                          if (item.url2) window.open(item.url2, "_blank");
                          if (item.url3) window.open(item.url3, "_blank");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

            </div>
          </div>
        </div>
        <div className="col-md-2"></div>
        </div>
    </>
  );
};

export default CarouselSecundarios;
